// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9241) return "static/chunks/9241-2338491807218e60.js";
	if (chunkId === 2972) return "static/chunks/2972-37022a999c0f28fd.js";
	if (chunkId === 6615) return "static/chunks/6615-98938d2ac4793591.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2209":"d6dd783e79b9f143","7339":"9099214dee1e950b","8614":"b2363a1806b5e8f4"}[chunkId] + ".js";
};